<div class="header">
  <spb-logo
    title="Borgoärenden"></spb-logo>
  <div class="right">
    <spb-toggle-button></spb-toggle-button>
    @if (service.currentUser()) {
      <span>{{ service.currentUser()?.name }}</span>
      <button [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    }
  </div>
</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="['admin']" mat-menu-item>Startsidan</button>
  @if (roleHelper.hookAdmin()) {
    <button [routerLink]="['krokar']" mat-menu-item>Nätkrokar</button>
  }
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>
